import {Button, FormCheck, FormControl} from 'react-bootstrap'
import {KTIcon} from '../../../../_metronic/helpers'
import {Field} from 'formik'

function MessageWindow() {
  return (
    <>
      <Field name={'content'}>
        {({field}: {field: any}) => (
          <div className="border-top border-secondary">
            <FormControl
              as="textarea"
              {...field}
              className="rounded-0 border-0 resize-none fw-normal"
              style={{backgroundColor: 'rgb(249 249 249)', height: '100px'}}
              autoComplete="off"
              placeholder="Type Message"
            />
          </div>
        )}
      </Field>

      <div className="bg-white px-6 py-4 d-flex gap-4 border-top border-secondary">
        <Field name="messageType">
          {({field, form}: {field: any; form: any}) => (
            <>
              <FormCheck
                label="Information"
                value="information"
                type="radio"
                id="info"
                name={field.name}
                onChange={field.onChange}
                checked={field.value === 'information'}
                className="form-check-xs fs-6 d-flex align-items-center gap-2"
              />

              <FormCheck
                label="Acknowledgment"
                value="acknowledgment"
                type="radio"
                id="acknowledgment"
                name={field.name}
                onChange={field.onChange}
                checked={field.value === 'acknowledgment'}
                className="form-check-xs fs-6 d-flex align-items-center gap-2"
              />
              <Button
                style={{
                  width: '50px',
                  height: '40px',
                }}
                variant="light"
                className={'d-flex justify-content-center align-items-center ms-auto p-0 pe-2 pt-1'}
                type="submit"
                disabled={!form.values.content || form.isSubmitting}
              >
                <span
                  style={{
                    transform: 'rotate(42deg)',
                  }}
                >
                  <KTIcon iconName="send" iconType="outline" className="fs-1" />
                </span>
              </Button>
            </>
          )}
        </Field>
      </div>
    </>
  )
}

export default MessageWindow
